import styled from 'styled-components'
import PropTypes from 'prop-types'
import { forwardRef, useContext } from 'react'
import { t } from 'ttag'

import { Globals } from '@h2/globals'
import { base, inputReset } from '@h2/components/mixins'
import { PB60T, SLB10S } from '@h2/components/colors'
import { SearchIcon } from '@h2/components/icons/search'

const fontSizes = {
  small: '14px',
  medium: '16px'
}
const padding = {
  small: '5px 14px',
  medium: '7px 16px'
}
const iconPadding = {
  small: '5px 14px 5px 34px',
  medium: '7px 16px 7px 38px'
}
const top = {
  small: '3px',
  medium: '6px'
}
const left = {
  small: '8px',
  medium: '10px'
}
const Wrapper = styled.span`
  position: relative;
  width: 100%;
  display: inline-block;
`
const IconWrap = styled.span`
  color: transparent;
  position: absolute;
  top: ${({ size }) => top[size]};
  left: ${({ size }) => left[size]};
`
const getPadding = ({ size, Icon }) => {
  if (Icon) {
    return iconPadding[size]
  }

  return padding[size]
}
const SearchInput = styled.input`
  ${inputReset};
  ${base};
  outline: 0;
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 17px;
  color: ${({ color }) => color};
  font-size: ${({ size }) => fontSizes[size]};
  padding: ${getPadding};
  width: 100%;

  &:focus {
    border-color: ${SLB10S};
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  }
`
const Input = forwardRef(function Input(
  {
    onInput,
    icon: Icon = SearchIcon,
    size = 'medium',
    color = 'black',
    borderColor = PB60T
  },
  ref
) {
  const { isLoggedIn, requireAuthentication, isEarlyLearnerMode, isNavianceElementary } =
    useContext(Globals)

  return !(isEarlyLearnerMode || isNavianceElementary) &&
    (isLoggedIn || !requireAuthentication) ? (
    <Wrapper>
      <SearchInput
        ref={ref}
        Icon={Icon}
        size={size}
        color={color}
        borderColor={borderColor}
        onInput={onInput}
        placeholder={t`Search`}
      />
      {Icon && (
        <IconWrap size={size}>
          <Icon />
        </IconWrap>
      )}
    </Wrapper>
  ) : null
})

Input.propTypes = {
  /** The icon to use in the input */
  icon: PropTypes.elementType,
  /** The color of the text inside the input */
  color: PropTypes.string,
  /** The border color of the input */
  borderColor: PropTypes.string,
  /** Callback when the input value changes */
  onInput: PropTypes.func.isRequired,
  /** The relative size of the input */
  size: PropTypes.oneOf(['small', 'medium'])
}

export { Input }
